import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import { knowledgeBaseGuidSelect } from "../util/widget";

@Form({title: "Article List Panel"})
export default class ArticleListPanelConfig {

	@Input({type: knowledgeBaseGuidSelect, title: "Knowledge Base"})
	public knowledgeBaseGuid: string;

	@Input({type: InputType.NUMBER_POSITIVE, title: "Default Page Size"})
	public defaultPageSize: number;

	@Input({type: InputType.CHECKBOX, title: "Full Text Search"})
	public queryFullText?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Save Search History"})
	public saveSearchHistory?: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/kb/config/ArticleListPanelConfig.ts